import React, { MouseEventHandler } from 'react';
import { DetailWidgetInteractionItem } from '../WidgetElement';
import { sendInteractGATrackEventData } from '../../../../util/gAUtil';

const Image = ({
	id,
	style,
	data,
	clickable,
	isHover,
	scenarioId,
	sceneId,
	onClick,
	handleMouseEnter,
	handleMouseLeave,
}: DetailWidgetInteractionItem) => {
	const {
		coordinate: { x, y },
		dimension: { w = 150, h = 100 },
		rotation,
	} = style;

	const centerPoint = {
		x: x + w - w / 2,
		y: y + h - h / 2,
	};

	const {
		settings: { imgUrl, bgImgUrl },
		name,
		type,
	} = data;

	const handleWidgetAction = (event: React.TouchEvent | React.MouseEvent) => {
		event.stopPropagation();
		sendInteractGATrackEventData(type, name, scenarioId, sceneId);
		onClick(event);
	};

	const imageSource = isHover ? bgImgUrl || imgUrl : imgUrl;
	return (
		<g key={id}
			id={id}
			onTouchStart={handleWidgetAction}
			onClick={handleWidgetAction}
			onMouseEnter={handleMouseEnter as MouseEventHandler<SVGGElement>}
			onMouseLeave={handleMouseLeave as MouseEventHandler<SVGGElement>}
		>
			<foreignObject
				x={x}
				y={y}
				width={w}
				height={h}
				style={{
					display: 'block',
					transformOrigin: `${centerPoint.x}px ${centerPoint.y}px`,
					transform: `rotate(${rotation ?? 0}deg)`,
					cursor: clickable ? 'pointer' : 'null',
				}}
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
						height: '100%',
					}}
				>
					<img
						className="widget image-widget"
						src={imageSource}
						style={{
							display: 'block',
							width: '100%',
						}}
					/>
				</div>
			</foreignObject>
		</g>
	);
};

export default Image;
